<template>
  <el-container style="height: 90%;padding: 0" class="border">
    <el-header  height="10%" style="padding: 0">
      <el-row style="text-align: center;margin-top: 2px">
        <el-col :span="4">
          <span style="color: whitesmoke;background-color: #04cc7c;text-align: center;border-radius: 2px;font-size: 18px;">&nbsp;{{ $t('makeSchedule.tzCalendarPage.todayIn') }}&nbsp;</span>
          <div style="font-weight: bold;text-align: center;font-size: 16px;">{{fromData.worker_num}}</div>
        </el-col>
        <el-col :span="4">
          <span style="color: whitesmoke;background-color: #67c23a;text-align: center;border-radius: 2px;font-size: 18px">&nbsp;{{ $t('makeSchedule.tzCalendarPage.inWujian') }}&nbsp;</span>
          <div style="font-weight: bold;text-align: center;font-size: 16px;">{{fromData.wujian_num}}</div>
        </el-col>
        <el-col :span="4">
          <span style="color: whitesmoke;background-color: rgb(217, 154, 79);text-align: center;border-radius: 2px;font-size: 18px">&nbsp;{{ $t('makeSchedule.tzCalendarPage.qclWeight') }}&nbsp;</span>
          <div style="font-weight: bold;text-align: center;font-size: 16px;">{{fromData.pretreatment_weight+'KG'}}</div>
        </el-col>
        <el-col :span="4">
          <span style="color: whitesmoke;background-color: #d57a0d;text-align: center;border-radius: 2px;font-size: 18px">&nbsp;{{ $t('makeSchedule.tzCalendarPage.qclArea') }}&nbsp;</span>
          <div style="font-weight: bold;text-align: center;font-size: 16px;">{{fromData.pretreatment_area+'m²'}}</div>
        </el-col>
        <el-col :span="4">
          <span style="color: whitesmoke;background-color: #40a9ff;text-align: center;border-radius: 2px;font-size: 18px">&nbsp;{{ $t('makeSchedule.tzCalendarPage.ptWeight') }}&nbsp;</span>
          <div style="font-weight: bold;text-align: center;font-size: 16px;">{{fromData.spray_weight+'KG'}}</div>
        </el-col>
        <el-col :span="4">
          <span style="color: whitesmoke;background-color: #096dd9;text-align: center;border-radius: 2px;font-size: 18px">&nbsp;{{ $t('makeSchedule.tzCalendarPage.ptArea') }}&nbsp;</span>
          <div style="font-weight: bold;text-align: center;font-size: 16px;">{{fromData.spray_area+'m²'}}</div>
        </el-col>
      </el-row>
    </el-header>
    <el-main style="padding: 0" >
      <el-calendar class="el-calendar" v-model="value" ref="calendar">
        <template #header="{ date }">
          <span></span>
          <h2 style="font-size: 20px">{{ date }}</h2>
          <el-button-group>
            <el-button style="font-size: 18px" @click="selectDate('prev-month')"><el-icon><ElIconArrowLeft /></el-icon></el-button>
            <el-button style="font-size: 16px" @click="selectDate('today')">今</el-button>
            <el-button style="font-size: 18px" @click="selectDate('next-month')"><el-icon><ElIconArrowRight /></el-icon></el-button>
          </el-button-group>
        </template>
        <template #date-cell="{ data }">
          <div :class="data.isSelected ?'dateDiv_1':'dateDiv'" :dataInfo="item=showWorkDate(data.day)">
            <text :class="data.isSelected ? 'is-selected' : ''" v-if="data.type === 'current-month'" class="dayDiv">
              {{ data.day.split('-').slice(2).join() >= 10 ? data.day.split('-').slice(2).join() : data.day.split('-').slice(2).join().replace(0, '') }}
            </text>
            <div class="div-text">
              <text class="workDiv" v-if="item.work_type==='work' && data.type === 'current-month'">{{ "班" }}</text>
              <text class="holidayDiv" v-if="item.work_type==='holiday' && data.type === 'current-month'">{{"节"}}</text>
              <text class="restDiv" v-if="item.work_type==='weekend' && data.type === 'current-month'">{{"休"}}</text>
            </div>

            <div class="row" v-if="data.type === 'current-month'">
              <div :class="item.day_shift_line_pretreatment == true?'day_shift_type_true':'day_shift_type_false'">{{ item.day_shift_line_pretreatment ? '前' : '' }}</div>
              <div :class="item.day_shift_line_powder == true?'day_shift_type_true':'day_shift_type_false'">{{ item.day_shift_line_powder ? '粉' : '' }}</div>
              <div :class="item.day_shift_line_liquid == true?'day_shift_type_true':'day_shift_type_false'">{{ item.day_shift_line_liquid ? '液' : '' }}</div>
            </div>

            <div class="row" v-if="data.type === 'current-month'">
              <div :class="item.night_shift_line_pretreatment == true?'night_shift_type_true':'night_shift_type_false'">{{ item.night_shift_line_pretreatment ? '前' : '' }}</div>
              <div :class="item.night_shift_line_powder == true?'night_shift_type_true':'night_shift_type_false'">{{ item.night_shift_line_powder ? '粉' : '' }}</div>
              <div :class="item.night_shift_line_liquid == true?'night_shift_type_true':'night_shift_type_false'">{{ item.night_shift_line_liquid ? '液' : '' }}</div>
            </div>
          </div>
        </template>
      </el-calendar>
    </el-main>
  </el-container>
</template>

<script>

export default {
  name: "PaintingCalendar",
  data() {
    return {
      value: new Date(),
      dateMap: [],
      fromData: {}
    }
  }, methods: {
    //total查询 组件自带
    selectDate(value) {
      this.$refs.calendar.selectDate(value)
      this.getWorkDateList(this.value)
    },
    getWorkDateList(date) {
      let params = {work_date: date}
      this.$axios.post('mfg/paintingCalendar/selectMonthData', params).then(response => {
        let res = response.data
        if (res.code !== 0) {
          this.$message.error("获取数据失败");
        }
        this.dateMap = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //显示工作日 日期
    showWorkDate(day) {
      if (this.dateMap[day]) {
        return this.dateMap[day]
      }
      return ""
    },
    getPaintingFromData() {
      this.$axios.post('mfg/paintingCalendar/getPaintingAreaData').then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("获取数据失败" + res.message);
        }
        this.fromData = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    }
  }, created() {
    this.getWorkDateList(this.value)
    this.getPaintingFromData()
  }
}
</script>

<style scoped>
.border {
  border: rgb(216, 220, 230) 1px solid;
}

.is-selected {
  color: #1989fa;
}

.border :deep(.el-calendar-day) {
  box-sizing: border-box;
  padding: 0;
  height: 100%;
}

.dayDiv {
  font-size: 18px;
}

.dateDiv {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}


.dateDiv_1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #c9f5cb;
}

.div-text {
  width: 28px;
  height: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin-bottom: 7px;
}


.restDiv {
  width: 28px;
  height: 28px;
  text-align: center;
  border-radius: 50%;
  color: #909399;
  background-color: #e5e5e5;
}

.workDiv {
  width: 28px;
  height: 28px;
  text-align: center;
  border-radius: 50%;
  color: whitesmoke;
  background-color: #0486fe;
}

.holidayDiv {
  width: 28px;
  height: 28px;
  text-align: center;
  border-radius: 50%;
  color: whitesmoke;
  background-color: #42b983;
}

.day_shift_type_true {
  padding: 0;
  border-radius: 0;
  width: 14%;
  line-height: 20px;
  height: 20px;
  background-color: #0486fe;
  color: white;
  text-align: center;
  font-size: 16px;
  margin-left: 6px;
  margin-bottom: 3px;
}

.day_shift_type_false {
  padding: 0;
  border-radius: 0;
  width: 14%;
  border: #0486fe 1px dashed;
  margin-left: 6px;
  margin-bottom: 3px;
  height: 20px;
}

.night_shift_type_true {
  padding: 0;
  border-radius: 0;
  width: 14%;
  height: 20px;
  line-height: 20px;
  background-color: #223342;
  color: white;
  font-size: 16px;
  margin-left: 6px;
  text-align: center;
  margin-bottom: 3px;
}

.night_shift_type_false {
  padding: 0;
  border-radius: 0;
  width: 14%;
  border: #223342 1px dashed;
  margin-left: 6px;
  height: 20px;
  margin-bottom: 3px;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  width: 100%;
  height: auto;
}

/*.border :deep(.el-calendar__body) {*/
/*  padding: 0;*/
/*}*/


</style>